import { JSX } from 'react';

import {
    List,
    TextField,
    Datagrid,
    DateField,
    EditButton,
    SelectField,
    useGetList, FunctionField,
} from 'react-admin';
import {
    Box,
} from '@mui/material';
import {ContactForm} from "../../../types/entities";
import { DashboardCard } from "./DashboardCard";
import { NewItemsBadge, ViewAllLink, dashboardColumnWidths, dashboardListSx } from "./ListWidgetChrome";
// See EnterpriseRequestsData: the pulse dot's rules live here, and this widget previously
// depended on a sibling importing them first.
import './styles/token-history-graphs.scss';

const formStatus: { id: string, name: string }[] = [
    { id: 'new', name: 'New' },
    { id: 'active', name: 'Active Conversation' },
    { id: 'dead', name: 'Failed to convert' },
    { id: 'customer', name: 'Converted to Customer' },
    { id: 'closed', name: 'Closed' },
];

// See EnterpriseRequestsData: same params for the count query and the <List> means one
// react-query key, so the two dedupe into a single request instead of two.
const LIST_QUERY = {
    pagination: { page: 1, perPage: 10 },
    sort: { field: 'id', order: 'DESC' as const },
    filter: { status: 'new' },
};

export const ContactFormData: () => JSX.Element = (): JSX.Element => {

    const { total, isPending, } = useGetList('contact_forms', LIST_QUERY);

    const ready: boolean = !isPending && total !== undefined;

    return (
        <DashboardCard
            eyebrow="Needs attention"
            title="Contact form messages"
            actions={ ready ? <NewItemsBadge total={ total } /> : undefined }
        >
            { /* Id, Name, Email, Status, Date added, Edit. One column fewer than the enterprise
                 card, so the email can take a larger share. */ }
            <Box
                className="contact-form"
                sx={ {
                    ...dashboardListSx,
                    ...dashboardColumnWidths(['56px', '24%', '36%', '17%', '23%', '64px']),
                } }
            >
                <List
                    title={ false }
                    resource="contact_forms"
                    actions={ false }
                    pagination={ false }
                    perPage={ LIST_QUERY.pagination.perPage }
                    sort={ LIST_QUERY.sort }
                    filter={ LIST_QUERY.filter }
                    empty={ false }
                >
                    <Datagrid bulkActionButtons={false} >
                        <TextField source="id" />
                        <FunctionField
                            label="Name"
                            render={ (record: ContactForm): string => `${record.firstname} ${record.lastname}` }
                        />
                        <TextField source="email" />
                        <SelectField source="status" choices={ formStatus } />
                        { /* Date only — see EnterpriseRequestsData. `ContactFormList` shows the
                             time as well, which is what "View all" is for. */ }
                        <DateField source="createdAt" label="Date added" />
                        { /* Icon only — see EnterpriseRequestsData. */ }
                        <EditButton label="" />
                    </Datagrid>
                </List>
            </Box>
            <ViewAllLink to="/contact_forms" label="View all contact messages" />
        </DashboardCard>
    );

}
